import * as React from 'react'
import GridItem from '../grid/GridItem'
import GridContainer from '../grid/GridContainer'
import CustomTabs from '../tab/CustomTabs'
import IndividualTenantPage from './IndividualTenantPage'
import IndividualEngagementApplication from './IndividualEngagementApplication'
import PersonIcon from '@material-ui/icons/Person'
import AssignmentIcon from '@material-ui/icons/Assignment'
import IndividualEngagements from './IndividualEngagements'
import DoneAllIcon from '@material-ui/icons/DoneAll'
import DepartmentInformation from './DepartmentInformation'

export default function IndividualTenantTab() {
  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          headerColor="primary"
          tabs={[
            {
              tabName: 'Meine Daten',
              tabIcon: PersonIcon,
              tabContent: <IndividualTenantPage/>,
            },
            {
              tabName: 'Meine Referate',
              tabIcon: DoneAllIcon,
              tabContent: <IndividualEngagements/>,
            },
            {
              tabName: 'Referatsbewerbung',
              tabIcon: AssignmentIcon,
              tabContent: <IndividualEngagementApplication/>,
            },
            {
              tabName: 'Referatsordnung',
              tabIcon: AssignmentIcon,
              tabContent: <DepartmentInformation/>,
            },
          ]}
        />
      </GridItem>
    </GridContainer>
  )
}
